var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import API from "@irati/utils/services/API";
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import { get, omit } from "lodash";
import getShortKey from "@irati/utils/getShortKey";
import endpoints from "../endpoints";
import dealsErrorHandler from "./errors/dealsErrorHandler";
import dealQuery, { dealQueryKey } from "./queries/deal";
import dealBySlugQuery, { dealBySlugQueryKey } from "./queries/dealBySlug";
var DealService = /** @class */ (function (_super) {
    __extends(DealService, _super);
    function DealService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealService.prototype.getDealByUrlSlug = function (urlSlug, options) {
        if (options === void 0) { options = {}; }
        var variables = { urlSlug: urlSlug };
        return client.query(__assign(__assign({}, options), { query: dealBySlugQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealBySlugQueryKey];
        });
    };
    DealService.prototype.getDeal = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealQueryKey];
        });
    };
    DealService.prototype.internalGetDeal = function (uuid, config) {
        if (config === void 0) { config = {}; }
        var url = endpoints.deal(uuid);
        if (config.expand) {
            url += "?expand=true";
        }
        return API.get(url, config).then(function (res) {
            hack(res.data);
            if (config.returnResponse) {
                return res;
            }
            return res.data;
        });
    };
    DealService.prototype.getDeals = function (params) {
        return API.get(endpoints.deals(), { params: params }).then(function (res) {
            var data = res.data;
            return data;
        });
    };
    DealService.prototype.getAvailableLocales = function () {
        return API.get(endpoints.dealLocales()).then(function (res) {
            var data = res.data;
            return data.data;
        });
    };
    DealService.prototype.createDeal = function (data) {
        var _this = this;
        var dealData = setSEO(data);
        return API.post(endpoints.deals(), dealData).then(function (res) {
            var uuid = getShortKey(res.data.links.self, "/v1/deals/");
            return _this.internalGetDeal(uuid).then(function (updatedDeal) { return updatedDeal; });
        });
    };
    DealService.prototype.saveDeal = function (uuid, deal, etag, config) {
        var _this = this;
        if (etag === void 0) { etag = deal.Etag; }
        if (config === void 0) { config = {}; }
        var dealData = setSEO(deal);
        return API.put(endpoints.deal(uuid), parseForPut(dealData), etag, config).then(function () {
            return _this.internalGetDeal(uuid);
        });
    };
    return DealService;
}(PBService));
var service = new DealService({ errorHandlers: [dealsErrorHandler] });
export default service;
export var getDealByUrlSlug = service.getDealByUrlSlug;
export var getDeal = service.getDeal;
export var internalGetDeal = service.internalGetDeal;
export var getDeals = service.getDeals;
export var getAvailableLocales = service.getAvailableLocales;
export var createDeal = service.createDeal;
export var saveDeal = service.saveDeal;
var parseForPut = function (deal) {
    return omit(deal, ["uuid", "date", "dateUnix", "popularity", "tenant"]);
};
function hack(deal) {
    var value = get(deal, "savings.userSavings.value", null);
    if (value) {
        deal.savings.userSavings.value = "" + value;
    }
}
/**
 * @description: Legacy SEO values, no longer needed but required by BE
 */
function setSEO(deal) {
    return __assign(__assign({}, deal), { seo: {
            pageTitle: null,
            metaDescription: null,
            metaKeywords: null,
            alt: null
        } });
}
